export default __webpack_public_path__ + "static/media/112.6aaa9c93.png";